import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ROUTE_PATHS } from '../constants';
import DisplayNotifications from '../pages/DisplayNotifications';
import OverruleCustomsLight from '../pages/OverruleCustomsLight';
import UseCases from '../pages/UseCases';
import SearchContainers from '../pages/SearchContainers';
import { hasPermission } from 'auth/helper';
import { Permission } from 'auth/permissions';

type Props = React.ComponentPropsWithoutRef<'div'> & {};

const BetaTerminalRoutes: React.FunctionComponent<Props> = () => {
  return (
    <Routes>
      {hasPermission(Permission.CAN_EDIT) && (
        <Route path={ROUTE_PATHS.OVERRULE_CUSTOMS_LIGHT} element={<OverruleCustomsLight />} />
      )}
      <Route path={ROUTE_PATHS.DISPLAY_NOTIFICATIONS} element={<DisplayNotifications />} />
      <Route path={ROUTE_PATHS.SEARCH_CONTAINERS} element={<SearchContainers />} />
      <Route path={ROUTE_PATHS.BASE_ROUTE} element={<UseCases />} />
    </Routes>
  );
};

export default BetaTerminalRoutes;
